/**
 * `CONTRACT_VERSION` — the versioned L3 contract surface (INV-CONTRACT-STABLE).
 *
 * Phase 3 freezes the surface at **`1.0.0-rc`** and RE-SYNCS the two constants:
 * the L3 runtime version (here) and the type-surface baseline mirrored in
 * `@progression/contracts` (§6.3) are now identical again. (Through Phase 2 the
 * runtime led the type-base by an additive `0.2.0` over `0.1.0`; that lead is now
 * closed, as planned.)
 *
 * The semver / deprecation rule every UI, module, and host binds to (see
 * REFERENCE.md → "Versioning & deprecation policy"):
 *   - PATCH / MINOR: additive, backward-compatible (a new command, a new query).
 *   - MAJOR: any breaking change to an existing command, query, event, or state
 *     shape — re-triggers conformance (INV-CONFORM) and forces modules/hosts to
 *     re-declare the version they bind to.
 *   - A command/query is removed only via the deprecation path: marked
 *     `@deprecated` for at least one MAJOR, then removed no earlier than the next.
 *
 * Pre-release ordering note: `1.0.0-rc` precedes `1.0.0`. The release-candidate
 * surface is stable for downstream binding; only fixes (not additions) are
 * expected before `1.0.0`.
 */
import { CONTRACT_VERSION as CONTRACT_VERSION_TYPE_BASE } from '@progression/contracts';
/** semver; a breaking change is a MAJOR bump that re-triggers conformance.
 * `1.1.0-rc`: additive-minor over `1.0.0-rc` for the Compute Integration seam
 * (`record-computation` + `evidenceOf`). Same MAJOR ⇒ old logs still load. */
export const CONTRACT_VERSION = '1.1.0-rc';
// Load-time guard: at the 1.0 freeze the runtime surface and the frozen
// type-surface baseline must be IDENTICAL (the additive lead is closed). A drift
// in either direction is now a contract defect we fail fast on.
if (CONTRACT_VERSION !== CONTRACT_VERSION_TYPE_BASE) {
    throw new Error(`@progression/app: CONTRACT_VERSION '${CONTRACT_VERSION}' is out of sync with the ` +
        `@progression/contracts type base '${CONTRACT_VERSION_TYPE_BASE}' (INV-CONTRACT-STABLE; ` +
        `the two must be re-synced together).`);
}
//# sourceMappingURL=version.js.map